// extracted by mini-css-extract-plugin
export var table = "_vo-0";